<template>
  <div class="quarries">
    <div
      class="mobile-show"
      style="
    width: 100vw;
    height: calc(100vw * 0.125);
    position:absolute;
    top:0;
    background: url(./img/mobile_header_bg1.jpg) center top  / cover;
    background-repeat: no-repeat;
    "
    ></div>
    <div class="container mobile-hide">
      <agile
        ref="imagecarousel"
        :autoplay="false"
        :speed="2000"
        :fade="true"
        :dots="false"
        :nav-buttons="false"
        style="height:400px;overflow:hidden;"
      >
        <div
          class="slide"
          style="background: url('./img/facilities_slide01.jpg') center center / cover;"
        ></div>
        <div
          class="slide"
          style="background: url('./img/facilities_slide02.jpg') center center / cover;"
        ></div>
        <div
          class="slide"
          style="background: url('./img/facilities_slide03.jpg') center center / cover;"
        ></div>
      </agile>
      <div
        style="
      width: 100%;
      height: 133px;
      position: absolute;
      top: 370px;
      background: url(./img/facilities_overlay.png) center center / cover;
      mix-blend-mode:multiply;
      "
      ></div>
      <div style="position:absolute;top:0;">
        <agile
          id="word-agile"
          :autoplay="true"
          :speed="2000"
          :autoplay-speed="5000"
          :fade="true"
          :dots="true"
          :nav-buttons="false"
          style="height:600px;overflow:hidden;"
          @beforeChange="syncslide"
        >
          <div class="slide" style="width:100%;">
            <div class="slide-overlay">
              <img src="img/chinese_diligent.png" alt width="48" />
            </div>
          </div>
          <div class="slide" style="width:100%;">
            <div class="slide-overlay">
              <img src="img/chinese_reliable.png" alt width="48" />
            </div>
          </div>
          <div class="slide" style="width:100%;">
            <div class="slide-overlay">
              <img src="img/chinese_precision.png" alt width="48" />
            </div>
          </div>
        </agile>
      </div>
    </div>
    <div class="mobile-unpad">
      <div
        class="container mobile-padding mobile-bg-blue"
        style="text-align:left;padding-bottom:30px;"
      >
        <div class="mobile-show" style="padding-top:30px;"></div>
        <span class="title-size">{{$t('body.facilities_quarries_title')}}</span>
        <div class="subtitlebodyblue">{{$t('body.facilities_quarries_sp1')}}</div>
      </div>
      <div class="container">
        <u-animate-container>
          <u-animate
            name="fadeInUp"
            delay="0s"
            duration="1s"
            :iteration="1"
            :offset="0"
            animateClass="animated"
            :begin="false"
          >
            <agile
              class="mobile-hide"
              ref="slide1"
              :autoplay="true"
              :speed="2000"
              :autoplay-speed="5000"
              :fade="true"
              :dots="true"
              :nav-buttons="false"
              style="height:500px;overflow:hidden;"
            >
              <div
                class="slide"
                style="background: url('./img/facilities_quarries01.jpg') center center / cover;height:500px;"
              ></div>
              <div
                class="slide"
                style="background: url('./img/facilities_quarries02.jpg') center center / cover;height:500px;"
              ></div>
              <div
                class="slide"
                style="background: url('./img/facilities_quarries03.jpg') center center / cover;height:500px;"
              ></div>
            </agile>
            <agile
              class="mobile-show"
              :autoplay="true"
              :speed="2000"
              :autoplay-speed="5000"
              :fade="true"
              :dots="true"
              :nav-buttons="false"
              style="height:200px;overflow:hidden;"
            >
              <div
                class="slide"
                style="background: url('./img/facilities_quarries01.jpg') center center / cover;height:200px;"
              ></div>
              <div
                class="slide"
                style="background: url('./img/facilities_quarries02.jpg') center center / cover;height:200px;"
              ></div>
              <div
                class="slide"
                style="background: url('./img/facilities_quarries03.jpg') center center / cover;height:200px;"
              ></div>
            </agile>
            <div style="height:24px;"></div>
          </u-animate>
        </u-animate-container>
        <u-animate-container>
          <u-animate
            name="fadeInUp"
            delay="0s"
            duration="1s"
            :iteration="1"
            :offset="0"
            animateClass="animated"
            :begin="false"
          >
            <agile
              class="mobile-hide"
              :autoplay="true"
              :speed="2000"
              :autoplay-speed="5000"
              :fade="true"
              :dots="true"
              :nav-buttons="false"
              style="height:500px;overflow:hidden;"
            >
              <div
                class="slide"
                style="background: url('./img/quarries02_01.jpg') center center / cover;height:500px;"
              ></div>
              <div
                class="slide"
                style="background: url('./img/quarries02_02.jpg') center center / cover;height:500px;"
              ></div>
              <div
                class="slide"
                style="background: url('./img/quarries02_03.jpg') center center / cover;height:500px;"
              ></div>
            </agile>
            <agile
              class="mobile-show"
              :autoplay="true"
              :speed="2000"
              :autoplay-speed="5000"
              :fade="true"
              :dots="true"
              :nav-buttons="false"
              style="height:200px;overflow:hidden;"
            >
              <div
                class="slide"
                style="background: url('./img/quarries02_01.jpg') center center / cover;height:200px;"
              ></div>
              <div
                class="slide"
                style="background: url('./img/quarries02_02.jpg') center center / cover;height:200px;"
              ></div>
              <div
                class="slide"
                style="background: url('./img/quarries02_03.jpg') center center / cover;height:200px;"
              ></div>
            </agile>
            <div style="height:24px;"></div>
          </u-animate>
        </u-animate-container>
      </div>
    </div>
    <div style="position:relative;top:150px;">
      <vfooter></vfooter>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
export default {
  name: "about",
  mounted() {
    // let self = this;
    // console.log("hello");
    // bulmaSteps.attach();
  },
  methods: {
    syncslide() {
      let self = this;
      console.log("syncslide");
      self.$refs.imagecarousel.goToNext();
    }
  }
};
</script>


<style scoped lang="scss">
.slide {
  width: 100%;
  height: 400px;
  // background: url("../assets/logo.png");
}
#word-agile div div div div.slide {
  width: 100%;
  height: 600px;
  // background: url("../assets/logo.png");
}
// .VueCarousel-pagination {
//   position: relative;
//   top: -80px;
// }

.slidetext {
  width: 500px;
  height: 400px;
  background: linear-gradient(to right, #013d57dd 70%, #013d5700);
  position: absolute;
  top: 0;
  left: 0;
  color: white;
  text-align: justify;
  padding: 24px 200px 0 24px;
  font-size: 20px;
}
.slide-overlay {
  height: 500px;
  font-size: 40px;
  line-height: 1;
  text-align: left;
  color: white;
  border-left: white solid 1px;
  position: relative;
  padding: 0 8px;
  top: 60px;
  left: 60px;
}

.slide-overlay::before {
  content: "";
  display: block;
  width: 4px;
  height: 100px;
  background: white;
  position: absolute;
  padding-left: 4px;
  top: 0;
  left: 0;
}
.agile__actions {
  position: relative;
  top: -100px;
}
</style>